import { useTheme } from '@mui/material';
import React from 'react';

export const CopyIcon = () => {
    const theme = useTheme();
    const {
        stroke: { secondary: secondaryStroke },
        background: { secondary: secondaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 17L21 41C21 43.2091 22.7909 45 25 45L43 45C45.2091 45 47 43.2091 47 41L47 17C47 14.7909 45.2091 13 43 13L25 13C22.7909 13 21 14.7909 21 17ZM19 41C19 44.3137 21.6863 47 25 47L43 47C46.3137 47 49 44.3137 49 41L49 17C49 13.6863 46.3137 11 43 11L25 11C21.6863 11 19 13.6863 19 17L19 41Z"
                fill={secondaryStroke}
            />
            <path
                d="M28 50C25.7909 50 24 48.2091 24 46L24 20C24 17.7909 25.7909 16 28 16L47 16C49.2091 16 51 17.7909 51 20L51 43C51 46.866 47.866 50 44 50L28 50Z"
                fill={secondaryBackground}
            />
            <path
                d="M16 44L16 22C16 20.7473 16.5759 19.6291 17.4773 18.8956C17.7824 18.6474 18 18.2929 18 17.8996V17.8996C18 17.1391 17.2423 16.6159 16.6148 17.0455C15.036 18.1263 14 19.9422 14 22L14 44C14 48.4183 17.5817 52 22 52L38 52C40.0175 52 41.8025 51.6006 42.8902 50.3454C43.3882 49.7706 42.8609 49 42.1004 49V49C41.7071 49 41.363 49.2333 41.0672 49.4925C40.3334 50.1354 39.2317 50 38 50L22 50C18.6863 50 16 47.3137 16 44Z"
                fill={secondaryStroke}
            />
        </svg>
    );
};
